import { query, waitForAllReturnWhenError } from '@confluence/query-preloader-tools';

import { preloadEmojiTitle } from '@confluence/emoji-title/entry-points/preloadEmojiTitle';
import { preloadEditorPageCoverPicture } from '@confluence/page-cover-picture/entry-points/preloadEditorPageCoverPicture';

import { SmartCreatePageEditorDataWrapperComponentQuery } from './SmartCreatePageEditorDataWrapperComponentQuery.graphql';
import type {
	SmartCreatePageEditorDataWrapperComponentQuery as SmartCreatePageEditorDataWrapperComponentQueryType,
	SmartCreatePageEditorDataWrapperComponentQueryVariables,
} from './__types__/SmartCreatePageEditorDataWrapperComponentQuery';

const preloadEditorData = async (contentId: string) => {
	return query<
		SmartCreatePageEditorDataWrapperComponentQueryType,
		SmartCreatePageEditorDataWrapperComponentQueryVariables
	>({
		query: SmartCreatePageEditorDataWrapperComponentQuery,
		variables: {
			contentId,
		},
	});
};

export const preloadSmartCreateEditorData = async (contentId: string) => {
	return waitForAllReturnWhenError([
		preloadEditorData(contentId),
		preloadEmojiTitle(contentId, '', false),
		preloadEditorPageCoverPicture(contentId, '', false),
	]);
};
